import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminV3SkillsPage } from '@apps/web/features/admin_v3_skills';

export const Route = createFileRoute('/_app/admin/agent/skills')({
    head: () => ({
        meta: [{ title: 'Skills | Internal Admin Agent' }],
    }),
    validateSearch: z.object({
        skill: z.string().min(1).optional().catch(undefined),
    }),
    component: SkillsRoute,
});

function SkillsRoute() {
    const { skill } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <AdminV3SkillsPage
            selected={skill ?? null}
            onSelect={(name) =>
                void navigate({
                    search: name === null ? {} : { skill: name },
                    replace: true,
                })
            }
        />
    );
}
